import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-share-print-download',
  templateUrl: './share-print-download.component.html',
  styleUrls: ['./share-print-download.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharePrintDownloadComponent {
  @Input() showPrint = false;
  @Input() showShare = false;
  @Input() isMobile = false;
  @Output() shareButtonClick = new EventEmitter();
  @Output() printButtonClick = new EventEmitter();
  @Output() downloadButtonClick = new EventEmitter();
  @Output() ellipsisButtonClick = new EventEmitter();

  emitShareClick() {
    this.shareButtonClick.emit();
  }

  emitPrintClick() {
    this.printButtonClick.emit();
  }

  emitDownloadClick() {
    this.downloadButtonClick.emit();
  }

  emitEllipsisClick() {
    this.ellipsisButtonClick.emit();
  }
}
